import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { BankUsersReportFilterParams, BankUsersReportResponse } from '~bank-reports/types/BankUsersReport'

export const bankUsersReportQueryOptions = (deps: Partial<BankUsersReportFilterParams>) =>
  queryOptions<BankUsersReportResponse>({
    queryKey: ['bankUsersReport', deps],
    queryFn: () => Request.post(Request.urls.bank.portalReportUser, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
